import React, { ComponentType } from "react";
import { SelectButton as SelectButtonComponent } from "@/app/components/storybook/Button/SelectButton";
import SelectButtonProps from "@/app/interfaces/props/SelectButtonProps";
import { ShapeTokensEnum } from "@/enums/tokens/shapeTokensEnum";
import { StateTokensEnum } from "@/enums/tokens/stateTokensEnum";
import { CommonHelper } from "../../../../stories/helpers/CommonHelper";

const iconMap: Record<string, ComponentType<any>> = CommonHelper.getFlattenedIcons(false);
const iconNames = CommonHelper.getSortedIconNames();

const selectButtonStates = [
  StateTokensEnum.DEFAULT,
  StateTokensEnum.HOVER,
  StateTokensEnum.FOCUS,
];

const SelectButton: React.FC<SelectButtonProps> = ({
  label = "Select",
  state = StateTokensEnum.DEFAULT,
  selected = false,
  shape = ShapeTokensEnum.RECTANGLE,
  iconSize,
  leftIcon,
  rightIcon,
}) => {
  const ResolvedLeftIcon = leftIcon ? iconMap[leftIcon as string] : undefined;
  const ResolvedRightIcon = rightIcon ? iconMap[rightIcon as string] : undefined;

  return (
    <SelectButtonComponent
      label={label}
      state={state}
      selected={selected}
      shape={shape}
      iconSize={iconSize}
      leftIcon={ResolvedLeftIcon}
      rightIcon={ResolvedRightIcon}
    />
  );
};

export default SelectButton;

export const selectButtonRegistration = {
  name: "Select Button",
  inputs: [
    {
      name: "label",
      type: "string",
      defaultValue: "Select",
    },
    {
      name: "shape",
      type: "string",
      enum: Object.values(ShapeTokensEnum),
      defaultValue: ShapeTokensEnum.RECTANGLE,
    },
    {
      name: "selected",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "state",
      type: "string",
      enum: selectButtonStates,
      defaultValue: StateTokensEnum.DEFAULT,
    },
    {
      name: "iconSize",
      type: "number",
      defaultValue: 20,
    },
    {
      name: "leftIcon",
      type: "string",
      enum: iconNames,
    },
    {
      name: "rightIcon",
      type: "string",
      enum: iconNames,
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/check.svg",
  description: "Add a select button component to the page",
};
